import React, { createContext, useContext, useState, useCallback } from "react";
import useIsMounted from "~/hooks/useIsMounted";

type TickerContextType = {
  hasTicker: boolean;
  showTicker: boolean;
  tickerContent: React.ReactNode | null;
  setTickerContent: Function;
  show: Function;
  hide: Function;
};
// create context
const TickerContext = createContext<TickerContextType>({
  hasTicker: false,
  showTicker: false,
  tickerContent: null,
  setTickerContent: () => {},
  show: () => {},
  hide: () => {},
});

export const useTickerContext = () => useContext(TickerContext);

// context provider
export const TickerContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isMounted = useIsMounted();
  const [hasTicker, setHasTicker] = useState(false);
  const [showTicker, setShowTicker] = useState(false);
  const [tickerContent, setTickerContentState] = useState<React.ReactNode | null>(
    null
  );

  const show = useCallback(() => {
    if (isMounted) setShowTicker(true);
  }, [isMounted]);
  
  const hide = useCallback(() => {
    if (isMounted) setShowTicker(true);
  }, [isMounted]);

  const setTickerContent = useCallback((content: React.ReactNode | null) => {
    if (isMounted) {
      setTickerContentState(content);
      setHasTicker(!!content)
    }
  }, [isMounted]);

  return (
    <TickerContext.Provider
      value={{
        hasTicker,
        tickerContent,
        showTicker,
        show,
        hide,
        setTickerContent,
      }}
    >
      {children}
    </TickerContext.Provider>
  );
};
